import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
    Button as MuiButton,
    ButtonProps as MuiButtonProps,
} from '@material-ui/core';

type ButtonProps = MuiButtonProps;

Button.defaultProps = {
    className: '',
    style: {},
};

const useStyle = makeStyles((theme: Theme) => createStyles({
    root: {

    },
}));

function Button(props: ButtonProps): React.ReactElement {
    const classes = useStyle();

    return (
        <MuiButton
            color="primary"
            variant="contained"
            size="large"
            {...props}
        />
    );
}

export { Button };
